import { Icon } from 'components/Icon';

// A celula da coluna Historico, compartilhada pelas telas do menu Cobranca.
//
// Ela nao mora em `columns.js` porque aquele arquivo descreve so o cabecalho:
// quem abre modal e a tela, pelos `overrides`. Mas o modal do historico e o
// mesmo nas seis telas — a regua, as tentativas e os alertas do contrato nao
// mudam conforme o degrau da esteira em que ele esta sendo olhado —, entao a
// celula fica aqui, e cada tela so faz o spread do resultado:
//
//   overrides: { ...buildHistoryOverride({ setModal, reload }) }
//
// Acao que for propria de uma tela (renegociar, na Cobranca) continua escrita
// no `overrides` dela.
export const buildHistoryOverride = ({ setModal, reload }) => ({
  historico: {
    renderCell: ({ row }) => (
      <Icon
        name="history"
        size={22}
        color="#2670D1"
        onClick={() => {
          setModal({ type: 'historico_cobranca', dados: row, reload });
        }}
        elementAttributes={{
          title: 'Histórico, régua e tentativas de cobrança',
          style: { cursor: 'pointer' },
        }}
      />
    ),
    // A linha do contrato nao representa parcela nenhuma: a representante do
    // grupo e so a primeira da ordenacao vigente, entao vincular a tentativa a
    // ela gravaria em uma parcela escolhida pelo sort. Aqui o historico abre no
    // escopo do contrato; para uma parcela especifica, expanda e use o icone da
    // linha dela.
    renderGroupCell: ({ row }) => (
      <Icon
        name="history"
        size={22}
        color="#2670D1"
        onClick={() => {
          setModal({
            type: 'historico_cobranca',
            dados: { ...row, tituloId: null, parcela: null },
            reload,
          });
        }}
        elementAttributes={{
          title: 'Histórico do contrato — expanda para uma parcela',
          style: { cursor: 'pointer' },
        }}
      />
    ),
  },
});
